import { TemplateRef } from '@angular/core';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as moment from 'moment';
import { TableComponent } from 'src/app/shared/common-components/table/table.component';
import { AdminService } from '../admin.service';

@Component({
  selector: 'app-year-cycle',
  templateUrl: './year-cycle.component.html',
  styleUrls: ['./year-cycle.component.scss']
})
export class YearCycleComponent implements OnInit {
  public formDialog: MatDialogRef<any> = null;
  public confirmDialog: MatDialogRef<any> = null;
  public tableData;
  public yearCycles: any;
  public showSpinner: boolean = false;
  public cycles: any;
  public yearId: any;
  public minDate = new Date(2021, 0, 1);
  @ViewChild('formRef') formRef: TemplateRef<any>;
  @ViewChild('confirmRef') confirmRef: TemplateRef<any>;

  @ViewChild(TableComponent, { static: false }) tableComp: TableComponent;
  selectedItem;
  yearCycleForm: FormGroup;
  public isReadonly: boolean = false;
  public maxDate: any;
  public todayDate = new Date();
  public cycleId:any;
  // public minDate = new Date(2021, 0, 1);
  private d1: any;
  private d2: any;
  private c: any;
  public disabled: boolean = false;
  // public columnNames = {
  //   // streetNumber: 'street No.',
  //   year: 'Year',
  //   // city: 'City',
  //   // state: 'State',
  //   // zipcode: 'Zip Code',
  //   startDate: 'Cycle Start Date',
  //   endDate: 'Cycle end Date',
  //   limit: 'Cycle limit',
  //   actions: '',
  // };
  public columnNames = {
    // streetNumber: 'street No.',
    // city: 'City',
    // state: 'State',
    // zipcode: 'Zip Code',
    startDate: 'Cycle Start Date',
    endDate: 'Cycle End Date',
    limit: 'Cycle Limit',
    'edit': ''
  };
  constructor(
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    private adminService: AdminService,
    private _snackBar: MatSnackBar,
  ) {

  }

  ngOnInit(): void {
    this.yearCycleForm = this.formBuilder.group({
      // streetNumber: ['', Validators.required],
      // year: ['', Validators.required],
      startDate: ['', Validators.required],
      endDate: ['', Validators.required],
      limit: ['', [Validators.required, Validators.max(99), Validators.min(1)]],
      // state: ['', Validators.required],
      // zipcode: ['', Validators.required],
    });
    // this.getYears();
    // this.getAllYearCycles();
    this.fetchAllCycles();

    this.adminService.getCycles().subscribe((res) => {
      this.cycles = res.cycleList;
    })

    this.yearCycleForm.controls['limit'].valueChanges.subscribe(
      (value) => {
        if (value < 1 || value > 99) {
          this.disabled = true;
        } else {
          this.disabled = false;
        }
      }
    );

  }
  // getYears() {
  //   this.showSpinner = true;
  //   this.adminService.getYearCycle().subscribe(res => {
  //     console.log(res);
  //     this.showSpinner = false;
  //     if (res.yearsList.length > 0) {
  //       // const UpdatedArr = res.streetsList.map((date: any) => date.createdAt ? { ...date, createdAt: moment(date.createdAt).format("Do MMM YY") } : date)
  //       // this.tableData = res.yearsList;
  //       let year = [];
  //       res.yearsList.map((data: any) => {
  //         this.adminService
  //         let yearData = {
  //           'year': data.year,
  //           'startDate': (data && data.cycle && data.cycle.startDate)? moment(data.cycle.startDate).format("MM/DD/YY") : null,
  //           'endDate': (data && data.cycle && data.cycle.endDate) ? moment(data.cycle.endDate).format("MM/DD/YY") : null,
  //           'limit': (data && data.cycle && data.cycle.limit) ? data.cycle.limit : null,
  //           'cycleId': (data && data.cycle && data.cycle.cycle) ? data.cycle.id : null,
  //           'yearId': data.id
  //         }
  //         year.push(yearData);
  //       })
  //       this.yearCycles = year;
  //       // this.showSpinner = false;

  //       this.tableRendering();
  //       // console.log(this.tableData, 'dataa')
  //     }
  //   })
  // }
  fetchAllCycles() {
    this.showSpinner = true;
    this.adminService.getCycles().subscribe(res => {
      console.log(res);
      this.showSpinner = false;
      if (res.cycleList.length > 0) {
        // const UpdatedArr = res.streetsList.map((date: any) => date.createdAt ? { ...date, createdAt: moment(date.createdAt).format("Do MMM YY") } : date)
        // this.tableData = res.yearsList;
        let year = [];
        let valid;
        res.cycleList.sort().map((data: any) => {
          if (data) {

            const cycleStartDate = moment(data.startDate).format('YYYY-MM-DD');
            const cycleEndDate = moment(data.endDate).format('YYYY-MM-DD');
            const checkDate = moment(new Date()).format('YYYY-MM-DD');
            this.d1 = cycleStartDate.split("/");
            this.d2 = cycleEndDate.split("/");
            this.c = checkDate.split("/");

            // const from = new Date( this.d1[2], parseInt( this.d1[1]) - 1,  this.d1[0]); // -1 because months are from 0 to 11
            // const to = new Date(this.d2[2], parseInt(this.d2[1]) - 1, this.d2[0]);
            // const check = new Date(this.c [2], parseInt(this.c [1]) - 1, this.c [0]);

            if (cycleEndDate < checkDate) {
              valid = true;
            }
            else {
              if (cycleStartDate == '2020-11-20' && cycleEndDate == '2020-12-31') {
                valid = true;
              } else {
                valid = false;
              }
            }
          }
          console.log(data)
          this.adminService
          let yearData = {
            'startDate': data ? moment(data.startDate).format("MM/DD/YY") : null,
            'endDate': data ? moment(data.endDate).format("MM/DD/YY") : null,
            'limit': data ? data.limit : null,
            'cycleId': data ? data.id : null,
            'excluded': valid
          }
          year.push(yearData);
        })

        this.yearCycles = year;
        // this.showSpinner = false;

        this.tableRendering();
        // console.log(this.tableData, 'dataa')
      }
    })
  }
  // getAllYearCycles(){
  //   this.showSpinner = true;
  //   this.adminService.getAllYearCycles().subscribe(res => {
  //     console.log(res);
  //     this.showSpinner = false;
  //     if (res.yearCyclesList.length > 0) {
  //       // const UpdatedArr = res.streetsList.map((date: any) => date.createdAt ? { ...date, createdAt: moment(date.createdAt).format("Do MMM YY") } : date)
  //       // this.tableData = res.yearsList;
  //       let year = [];
  //       res.yearCyclesList.sort().map((data: any) => {
  //         this.adminService
  //         let yearData = {
  //           'year': data.years.year,
  //           'startDate': (data && data.cycle && data.cycle.startDate)? moment(data.cycle.startDate).format("MM/DD/YY") : null,
  //           'endDate': (data && data.cycle && data.cycle.endDate) ? moment(data.cycle.endDate).format("MM/DD/YY") : null,
  //           'limit': (data && data.cycle && data.cycle.limit) ? data.cycle.limit : null,
  //           'cycleId': (data && data.cycle) ? data.cycle.id : null,
  //           'yearId': data.years.id
  //         }
  //         year.push(yearData);
  //       })
  //       this.yearCycles = year;
  //       // this.showSpinner = false;

  //       this.tableRendering();
  //       // console.log(this.tableData, 'dataa')
  //     }
  //   })
  // }

  openDialogForm() {
    if (this.cycleId) {
      this.isReadonly = true;
    } else {
      this.isReadonly = false;
    }

    console.log(this.selectedItem, 'submitt')
    this.formDialog = this.dialog.open(this.formRef, {
      width: '350px',
      data: 'data'
    });
    this.formDialog.afterClosed().subscribe(result => {
      this.selectedItem = '';
      this.yearCycleForm.reset();
      this.yearId = null;
      this.cycleId = null;
    })
  }

  onSubmit() {
    // this.yearCycleForm.value['startDate'] = new Date(this.yearCycleForm.value['startDate']).toLocaleString();
    // this.yearCycleForm.value['endDate'] = new Date(this.yearCycleForm.value['endDate']).toLocaleString();
    this.adminService.addCycles(this.yearCycleForm.value).subscribe((res) => {
      this.formDialog.close();
      this.yearCycleForm.reset();
      this._snackBar.open('Success :' + res.message, '', {
        duration: 3000,
        horizontalPosition: 'right',
        panelClass: 'success-snackbar'
      });
      this.fetchAllCycles();
    }, error => {
      let errorMessage: string;
      if (error.error.message) {
        errorMessage = error.error.message;
      } else {
        errorMessage = `${error.message}`;
      }
      if (errorMessage == 'Cycle already exists') {
        this._snackBar.open('Warning :' + errorMessage, '', {
          duration: 3000,
          horizontalPosition: 'right',
          panelClass: 'warning-snackbar'
        });
      } else {
        console.log(error);
        this._snackBar.open('Error :' + errorMessage, '', {
          duration: 3000,
          horizontalPosition: 'right',
          panelClass: 'error-snackbar'
        });
      }
    });
  }

  selectedItems(item) {
    this.selectedItem = item.data;
    if (item.action === 'edit') {
      this.yearId = item.data.yearId;
      this.cycleId = item.data.cycleId;
      // this.yearCycleForm.controls['year'].disable();
      this.yearCycleForm.patchValue({
        //  streetNumber: item.data.streetNumber,
        year: item.data.year,
        startDate: new Date(item.data.startDate),
        endDate: new Date(item.data.endDate),
        limit: item.data.limit,
        // state: item.data.state,
        // zipcode: item.data.zipcode,
      });
      this.openDialogForm();

    } else {
      this.confirmDialog = this.dialog.open(this.confirmRef, {
        width: '350px',
        data: 'data'
      });
    }
  }

  confirmDelete() {
    this.deleteCycle(this.selectedItem);
    this.fetchAllCycles();
    this.confirmDialog.close();
    this.selectedItem = '';
  }

  onNoClick() {
    this.confirmDialog.close();
  }

  editYearCycle(e) {
    e.preventDefault();
    // this.yearCycleForm.controls['year'].disable()
    this.showSpinner = true;
    this.yearCycleForm.value['cycleId'] = this.selectedItem.cycleId;
    this.adminService.updateCycles(this.yearCycleForm.value).subscribe((res) => {
      this.showSpinner = false;
      this.formDialog.close();
      this.yearCycleForm.reset();
      this.selectedItem = '';
      // if (res.message == 'Cycle already exists with star date and end date') {
      //   this._snackBar.open('Warning :' + res.message, '', {
      //     duration: 3000,
      //     horizontalPosition: 'right',
      //     panelClass: 'warning-snackbar'
      //   });
      //   return;
      // } else {
      this._snackBar.open('Success :' + res.message, '', {
        duration: 3000,
        horizontalPosition: 'right',
        panelClass: 'success-snackbar'
      });
      // }
      console.log(this.selectedItem, 'editt')

      this.fetchAllCycles();
    }, error => {
      let errorMessage: string;
      if (error.error.message) {
        errorMessage = error.error.message;
      } else {
        errorMessage = `${error.message}`;
      }
      if (errorMessage == 'Cycle already exists with star date and end date') {
        this._snackBar.open('Warning :' + errorMessage, '', {
          duration: 3000,
          horizontalPosition: 'right',
          panelClass: 'warning-snackbar'
        });
        this.showSpinner = false;
      } else {
        console.log(error);
        this._snackBar.open('Warning :' + errorMessage, '', {
          duration: 3000,
          horizontalPosition: 'right',
          panelClass: 'warning-snackbar'
        });
        this.showSpinner = false;
      }

    });
  }

  deleteYear(year) {
    this.adminService.deleteYear(year).subscribe((res) => {
      this._snackBar.open('Success :' + res.message, '', {
        duration: 5000,
        horizontalPosition: 'right',
        panelClass: 'success-snackbar'
      });
      console.log(res)
      this.fetchAllCycles();
    });
  }

  deleteCycle(year) {
    this.adminService.deleteCycle(year).subscribe((res) => {
      this._snackBar.open('Success :' + res.message, '', {
        duration: 5000,
        horizontalPosition: 'right',
        panelClass: 'success-snackbar'
      });
      this.selectedItem = '';
      console.log(res)
      this.fetchAllCycles();
    });
    this.fetchAllCycles();
  }

  tableRendering() {
    console.log('inside table rendering')
    if (this.tableComp != undefined) {
      console.log('inside if rendering')
      this.fetchAllCycles();
      this.tableComp.renderTable();
    }
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    console.log('key.....', event.key);
    if (event.key > 0) {
      return true;
    }
    if (charCode >= 96 && charCode <= 106) {
      return true;
    }
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
}
